<template>
    <div>
        <h4>Node Chapter 1</h4>
        <p>テスト用、、、。</p>
    </div>
</template>

<script>
    export default{
        name: 'NodeChapter1',
    }
</script>